import { $axios, apiList } from '@/api'

export default {
    actions: {
        getCertificates() {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.cert.getCertificates.method,
                    params: {
                        wsfunction: apiList.cert.getCertificates.moodle_method
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getCertificate(_, id) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.cert.getCertificate.method,
                    params: {
                        wsfunction: apiList.cert.getCertificate.moodle_method,
                        id: id
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
